import { pushDataLayerEvent } from '../consent/services/gtm'
import type { OnboardingStepKey } from '../../config/onboardingRegistry'

export type OnboardingForfeitReason =
  | 'too_many_steps'
  | 'already_know_product'
  | 'other'

export function trackOnboardingStepStarted(stepKey: OnboardingStepKey) {
  pushDataLayerEvent({
    event: 'onboarding_step_started',
    step_key: stepKey,
  })
}

export function trackOnboardingStepCompleted(stepKey: OnboardingStepKey) {
  pushDataLayerEvent({
    event: 'onboarding_step_completed',
    step_key: stepKey,
  })
}

export function trackOnboardingForfeit(reason: OnboardingForfeitReason) {
  pushDataLayerEvent({
    event: 'onboarding_forfeit',
    forfeit_reason: reason,
  })
}

export function trackOnboardingRoiCardShown(
  stepKey: 'titles_flow' | 'descriptions_flow' | 'grafikomat_flow' | 'parameters_flow',
) {
  pushDataLayerEvent({
    event: 'onboarding_roi_card_shown',
    step_key: stepKey,
  })
}

export function trackOnboardingCompletionModalShown(recommendedPlan: string, offerCount: number) {
  pushDataLayerEvent({
    event: 'onboarding_completion_modal_shown',
    recommended_plan: recommendedPlan,
    offer_count: offerCount,
  })
}
